(function() {
  if (window.SusucarProductBuilderLoaded) return;
  window.SusucarProductBuilderLoaded = true;

  function addDeliveryDays(startDate, numberOfDays, skipWeekends) {
    var result = new Date(startDate.getTime());
    var addedDays = 0;

    while (addedDays < numberOfDays) {
      result.setDate(result.getDate() + 1);

      if (skipWeekends && (result.getDay() === 0 || result.getDay() === 6)) {
        continue;
      }

      addedDays += 1;
    }

    return result;
  }

  function formatDeliveryDate(date, locale, dateFormat) {
    var options = {
      month: dateFormat === 'long' ? 'long' : 'short',
      day: 'numeric'
    };

    if (dateFormat === 'long') options.weekday = 'long';
    if (date.getFullYear() !== new Date().getFullYear()) options.year = 'numeric';

    try {
      return new Intl.DateTimeFormat(locale || 'en-US', options).format(date);
    } catch (error) {
      return new Intl.DateTimeFormat('en-US', options).format(date);
    }
  }

  function initializeDeliveryEstimate(container) {
    if (container.dataset.deliveryInitialized === 'true') return;

    var output = container.querySelector('[data-delivery-dates]');
    var minimumDays = Math.max(0, parseInt(container.dataset.minDays, 10) || 0);
    var maximumDays = Math.max(minimumDays, parseInt(container.dataset.maxDays, 10) || minimumDays);
    var skipWeekends = container.dataset.skipWeekends === 'true';
    var dateFormat = container.dataset.dateFormat || 'long';
    var locale = container.dataset.locale || 'en-US';
    var today = new Date();

    today.setHours(0, 0, 0, 0);

    var earliestDate = addDeliveryDays(today, minimumDays, skipWeekends);
    var latestDate = addDeliveryDays(today, maximumDays, skipWeekends);
    var earliestText = formatDeliveryDate(earliestDate, locale, dateFormat);
    var latestText = formatDeliveryDate(latestDate, locale, dateFormat);

    if (output) {
      output.textContent = earliestText === latestText ? earliestText : earliestText + ' - ' + latestText;
    }

    container.dataset.deliveryInitialized = 'true';
  }

  function getMobileStickyOffset() {
    if (window.matchMedia('(min-width: 992px)').matches && document.querySelector('.header-style-6 .header-desktop')) {
      var desktopValue = parseFloat(window.getComputedStyle(document.documentElement).getPropertyValue('--susucar-desktop-sticky-height'));
      if (Number.isFinite(desktopValue) && desktopValue > 0) return desktopValue;
      var desktopTop = document.querySelector('.header-style-6 .header-desktop .header-content_top');
      var desktopNav = document.querySelector('.header-style-6 .header-desktop .header-content_bottom');
      if (desktopTop && desktopNav) return desktopTop.getBoundingClientRect().height + desktopNav.getBoundingClientRect().height;
    }
    var value = window.getComputedStyle(document.documentElement)
      .getPropertyValue('--susucar-mobile-sticky-header-offset');
    var parsedValue = parseFloat(value);

    return Number.isFinite(parsedValue) ? parsedValue : 94;
  }

  function centerProductNavControl(control) {
    var navigation = control.parentElement;

    if (!navigation) return;

    var left = control.offsetLeft - (navigation.clientWidth - control.offsetWidth) / 2;
    navigation.scrollTo({ left: Math.max(0, left), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  }

  function setActiveProductNav(controls, activeControl, shouldCenter) {
    controls.forEach(function(control) {
      var isActive = control === activeControl;
      control.classList.toggle('active', isActive);

      if (isActive) {
        control.setAttribute('aria-current', 'location');
      } else {
        control.removeAttribute('aria-current');
      }
    });

    if (shouldCenter && activeControl) centerProductNavControl(activeControl);
  }

  function scrollToProductPanel(container, controls, control, navigation) {
    var target = container.querySelector(control.dataset.target);
    navigation = navigation || container.querySelector('.product_tab-contorls');

    if (!target) return;

    var navigationHeight = navigation ? navigation.offsetHeight : 0;
    var targetTop = window.scrollY + target.getBoundingClientRect().top;
    var destination = Math.max(0, targetTop - getMobileStickyOffset() - navigationHeight - 8);

    setActiveProductNav(controls, control, true);
    window.scrollTo({ top: destination, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  }

  function initializeProductTabs(container) {
    if (container.dataset.tabsEnhanced === 'true') return;

    var controls = Array.prototype.slice.call(container.querySelectorAll('.js-tab-control'));
    var navigation = container.querySelector('.product_tab-contorls');
    var mobileQuery = window.matchMedia('(max-width: 767px)');
    if (!controls.length || !navigation) return;

    var list = navigation.querySelector('.js-tab-controls');
    var abortController = new AbortController();
    var descriptions = [];
    var panels = controls.map(function(control) { return container.querySelector(control.dataset.target); });
    var selected = controls.find(function(control, index) { return control.classList.contains('active') && panels[index]; }) || controls[0];

    container.querySelectorAll('.susucar-product-tabs__overview').forEach(function(overview, overviewIndex) {
      var originalId = overview.getAttribute('id');
      if (!overview.id) overview.id = 'susu-description-' + container.dataset.sectionId + '-' + overviewIndex;
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'susucar-overview-toggle susucar-description-toggle';
      button.setAttribute('aria-controls', overview.id);
      button.hidden = true;
      overview.after(button);
      var entry = {
        overview: overview, originalId: originalId, button: button, expanded: false,
        groups: Array.prototype.map.call(overview.children, function(node) { return { node: node, hidden: node.hidden, inert: node.inert }; })
      };
      descriptions.push(entry);
      button.addEventListener('click', function() {
        entry.expanded = !entry.expanded;
        synchronizeDescription(entry);
        if (!entry.expanded) {
          var index = panels.indexOf(overview.closest('.js-tab-content'));
          if (index >= 0) scrollToProductPanel(container, controls, controls[index], navigation);
        }
      }, { signal: abortController.signal });
      overview.addEventListener('load', function() { synchronizeDescription(entry); }, { capture: true, signal: abortController.signal });
    });

    function restoreDescription(entry) {
      entry.overview.classList.remove('susucar-description-clipped');
      entry.overview.style.removeProperty('--susucar-description-height');
      entry.groups.forEach(function(group) { group.node.hidden = group.hidden; group.node.inert = group.inert; });
    }

    function synchronizeDescription(entry) {
      Array.prototype.forEach.call(entry.overview.children, function(node) {
        if (!entry.groups.some(function(group) { return group.node === node; })) entry.groups.push({ node: node, hidden: node.hidden, inert: node.inert });
      });
      restoreDescription(entry);
      entry.button.hidden = true;
      entry.button.setAttribute('aria-expanded', 'true');
      if (!mobileQuery.matches) return;
      var overview = entry.overview;
      var fullHeight = overview.scrollHeight;
      if (fullHeight <= 220) return;
      entry.button.hidden = false;
      if (!entry.expanded) {
        var origin = overview.getBoundingClientRect().top;
        var visible = entry.groups.filter(function(group) { return !group.hidden && group.node.getBoundingClientRect().height > 0; });
        var boundary = 0;
        visible.forEach(function(group, index) {
          var node = group.node;
          var next = visible[index + 1];
          var bottom = node.getBoundingClientRect().bottom - origin;
          var headingWithoutBody = /^H[1-6]$/.test(node.tagName) && next && next.node.getBoundingClientRect().bottom - origin > 200;
          if (!headingWithoutBody && bottom <= 200 && visible.slice(0, index).every(function(previous) { return previous.node.getBoundingClientRect().bottom - origin <= 200; })) boundary = Math.max(boundary, bottom);
        });
        var limit = boundary >= 40 ? Math.ceil(boundary) : 180;
        var first = visible[0] && visible[0].node;
        if (boundary < 40 && first && (first.matches('table,figure,video,iframe') || first.querySelector('a,button,input,select,textarea,video,iframe,table'))) limit = Math.ceil(first.getBoundingClientRect().bottom - origin);
        entry.groups.forEach(function(group) {
          if (!group.hidden && group.node.getBoundingClientRect().top - origin >= limit - 1) { group.node.hidden = true; group.node.inert = true; }
        });
        if (fullHeight > limit + 16) {
          overview.style.setProperty('--susucar-description-height', limit + 'px');
          overview.classList.add('susucar-description-clipped');
        } else {
          restoreDescription(entry);
          entry.button.hidden = true;
        }
      }
      entry.button.textContent = entry.expanded ? 'Read less' : 'Read more';
      entry.button.setAttribute('aria-expanded', String(entry.expanded || entry.button.hidden));
    }

    var navigationOrigin = document.createComment('susucar-product-nav-origin');
    navigation.before(navigationOrigin);
    var scrollUntil = 0;
    var scrollFrame = 0;
    var descriptionObserver = typeof MutationObserver === 'function' ? new MutationObserver(function() { descriptions.forEach(synchronizeDescription); }) : null;
    if (descriptionObserver) descriptions.forEach(function(entry) { descriptionObserver.observe(entry.overview, { childList: true, subtree: true, characterData: true }); });

    function mountNavigation() {
      var header = document.querySelector('.header-style-6 .header-mobile.susu-mobile-compact .header-content_top');
      if (mobileQuery.matches && header && !container.classList.contains('susucar-tabs--disabled')) {
        navigation.classList.add('susucar-mobile-product-nav');
        navigation.dataset.productNavOwner = container.dataset.sectionId;
        if (navigation.parentElement !== header) header.appendChild(navigation);
      } else {
        if (navigationOrigin.parentNode && navigation.previousSibling !== navigationOrigin) navigationOrigin.after(navigation);
        navigation.classList.remove('susucar-mobile-product-nav');
        delete navigation.dataset.productNavOwner;
      }
    }

    function activateProductAnchor(control, shouldScroll) {
      var index = controls.indexOf(control);
      if (!panels[index]) return;
      selected = control;
      setActiveProductNav(controls, control, shouldScroll);
      panels.forEach(function(panel) {
        if (panel) { panel.hidden = false; panel.inert = false; }
      });
      if (shouldScroll) {
        scrollUntil = Date.now() + 900;
        scrollToProductPanel(container, controls, control, navigation);
      }
    }

    function synchronizeLayout() {
      mountNavigation();
      container.classList.toggle('susucar-tabs--mobile-panels', mobileQuery.matches);
      if (list) list.removeAttribute('role');
      controls.forEach(function(control, index) {
        var target = panels[index];
        if (!target) return;
        var controlId = 'susucar-anchor-' + container.dataset.sectionId + '-' + index;
        control.id = controlId;
        control.setAttribute('role', 'link');
        control.setAttribute('aria-controls', target.id);
        target.setAttribute('role', 'region');
        target.setAttribute('aria-labelledby', controlId);
        control.removeAttribute('aria-selected');
        control.tabIndex = 0;
        target.hidden = false;
        target.inert = false;
      });
      activateProductAnchor(selected, false);
      descriptions.forEach(synchronizeDescription);
      if (mobileQuery.matches && selected) {
        var bounds = list.getBoundingClientRect();
        var selectedBounds = selected.getBoundingClientRect();
        if (selectedBounds.left < bounds.left + 8 || selectedBounds.right > bounds.right - 8) {
          list.scrollTo({ left: Math.max(0, selected.offsetLeft - (list.clientWidth - selected.offsetWidth) / 2), behavior: 'instant' });
        }
      }
    }

    function revealAnchor(target) {
      if (!mobileQuery.matches || !target || !container.contains(target)) return;
      var panel = target.closest('.js-tab-content');
      var index = panels.indexOf(panel);
      if (index < 0) return;
      descriptions.forEach(function(entry) {
        if (entry.overview.contains(target)) {
          entry.expanded = true;
          synchronizeDescription(entry);
        }
      });
      activateProductAnchor(controls[index], false);
    }

    function handleHash() {
      try { revealAnchor(document.getElementById(decodeURIComponent(window.location.hash.slice(1)))); } catch (error) { return; }
    }

    controls.forEach(function(control, index) {
      control.addEventListener('click', function() { activateProductAnchor(control, true); }, { signal: abortController.signal });
      control.addEventListener('keydown', function(event) {
        var nextIndex;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % controls.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + controls.length) % controls.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = controls.length - 1;
        if (typeof nextIndex === 'number') {
          event.preventDefault();
          controls[nextIndex].focus({ preventScroll: true });
          if (mobileQuery.matches) activateProductAnchor(controls[nextIndex], true);
        } else if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          activateProductAnchor(control, true);
        }
      }, { signal: abortController.signal });
    });

    document.addEventListener('click', function(event) {
      var link = event.target.closest && event.target.closest('a[href]');
      if (!link) return;
      try {
        var url = new URL(link.href, window.location.href);
        if (url.origin === window.location.origin && url.pathname === window.location.pathname && url.search === window.location.search && url.hash) revealAnchor(document.getElementById(decodeURIComponent(url.hash.slice(1))));
      } catch (error) { return; }
    }, { capture: true, signal: abortController.signal });
    window.addEventListener('resize', synchronizeLayout, { signal: abortController.signal });
    document.addEventListener('susucar:mobile-header:change', mountNavigation, { signal: abortController.signal });
    window.addEventListener('scroll', function() {
      if (!mobileQuery.matches || scrollFrame) return;
      scrollFrame = window.requestAnimationFrame(function() {
        scrollFrame = 0;
        if (Date.now() < scrollUntil) return;
        var valid = panels.filter(function(panel) { return panel && panel.getBoundingClientRect().height > 0; });
        var offset = getMobileStickyOffset() + navigation.offsetHeight + 12;
        var current = valid.filter(function(panel) { return panel.getBoundingClientRect().top <= offset; }).pop();
        if (window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - 2 && valid.length) current = valid[valid.length - 1];
        if (current) { selected = controls[panels.indexOf(current)]; setActiveProductNav(controls, selected, false); }
      });
    }, { passive: true, signal: abortController.signal });
    window.addEventListener('hashchange', handleHash, { signal: abortController.signal });
    document.addEventListener('shopify:section:unload', function(event) {
      if (event.target !== container && !event.target.contains(container)) {
        if (event.target.contains(navigation) && navigationOrigin.parentNode) navigationOrigin.after(navigation);
        return;
      }
      abortController.abort();
      if (descriptionObserver) descriptionObserver.disconnect();
      if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
      if (navigationOrigin.parentNode) navigationOrigin.replaceWith(navigation);
      navigation.classList.remove('susucar-mobile-product-nav');
      delete navigation.dataset.productNavOwner;
      panels.forEach(function(panel) { if (panel) { panel.hidden = false; panel.inert = false; } });
      descriptions.forEach(function(entry) {
        restoreDescription(entry);
        entry.button.remove();
        if (entry.originalId === null) entry.overview.removeAttribute('id');
        else entry.overview.id = entry.originalId;
      });
      container.classList.remove('susucar-tabs--mobile-panels');
      delete container.dataset.tabsEnhanced;
    }, { signal: abortController.signal });

    synchronizeLayout();
    handleHash();
    container.dataset.tabsEnhanced = 'true';
  }

  function initializeProductAccordion(container) {
    if (container.dataset.productAccordionInitialized === 'true') return;

    var items = Array.prototype.slice.call(container.querySelectorAll('[data-product-spec-accordion-item]'));

    items.forEach(function(item) {
      item.addEventListener('toggle', function() {
        if (!item.open) return;

        items.forEach(function(otherItem) {
          if (otherItem !== item) otherItem.open = false;
        });
      });
    });

    container.dataset.productAccordionInitialized = 'true';
  }

  function parseStructuredLine(rawLine) {
    var line = rawLine.trim();
    var separatorIndex = line.search(/[:\uFF1A]/);

    if (!line || separatorIndex <= 0 || separatorIndex > 80) return null;

    var label = line.slice(0, separatorIndex).replace(/^[-*]\s*/, '').trim();
    var value = line.slice(separatorIndex + 1).trim();

    return label && value ? [label, value] : null;
  }

  function getStructuredLines(node) {
    var clone = node.cloneNode(true);

    if (clone.nodeType === 3) {
      return clone.textContent.split(/\r?\n/).map(function(line) {
        return line.trim();
      }).filter(Boolean);
    }

    clone.querySelectorAll('br').forEach(function(element) {
      element.replaceWith(document.createTextNode('\n'));
    });
    clone.querySelectorAll('p, li, div').forEach(function(element) {
      element.appendChild(document.createTextNode('\n'));
    });

    return clone.textContent.split(/\r?\n/).map(function(line) {
      return line.trim();
    }).filter(Boolean);
  }

  function createSpecificationTable(rows) {
    var table = document.createElement('table');
    var body = document.createElement('tbody');
    table.className = 'susucar-metafield-table__table';

    rows.forEach(function(row) {
      var tableRow = document.createElement('tr');
      var label = document.createElement('th');
      var value = document.createElement('td');

      label.scope = 'row';
      label.textContent = row[0];
      value.textContent = row[1];
      tableRow.appendChild(label);
      tableRow.appendChild(value);
      body.appendChild(tableRow);
    });

    table.appendChild(body);
    return table;
  }

  function initializeStructuredContent(container) {
    if (container.dataset.structuredContentInitialized === 'true') return;
    if (container.querySelector('[data-source-field-table]')) {
      container.dataset.structuredContentInitialized = 'true';
      return;
    }

    var output = document.createDocumentFragment();
    var pendingRows = [];
    var foundRows = false;

    function flushRows() {
      if (!pendingRows.length) return;

      var tableRows = pendingRows;

      if (container.hasAttribute('data-interchange-group-labels')) {
        tableRows = [];
        var rowsByLabel = Object.create(null);

        pendingRows.forEach(function(row) {
          var groupedRow = rowsByLabel[row[0]];
          if (groupedRow) {
            groupedRow[1] += ', ' + row[1];
          } else {
            groupedRow = [row[0], row[1]];
            rowsByLabel[row[0]] = groupedRow;
            tableRows.push(groupedRow);
          }
        });
      }

      output.appendChild(createSpecificationTable(tableRows));
      pendingRows = [];
    }

    Array.prototype.slice.call(container.childNodes).forEach(function(node) {
      if (node.nodeType === 1 && /^H[1-6]$/.test(node.tagName)) {
        flushRows();
        output.appendChild(node.cloneNode(true));
        return;
      }

      if (node.nodeType === 3 && !node.textContent.trim()) return;

      var lines = getStructuredLines(node);
      var parsedLines = lines.map(function(line) {
        return { text: line, row: parseStructuredLine(line) };
      });
      var hasRows = parsedLines.some(function(item) {
        return item.row;
      });

      if (!hasRows) {
        flushRows();
        output.appendChild(node.cloneNode(true));
        return;
      }

      parsedLines.forEach(function(item) {
        if (item.row) {
          pendingRows.push(item.row);
          foundRows = true;
          return;
        }

        flushRows();
        var paragraph = document.createElement('p');
        paragraph.textContent = item.text;
        output.appendChild(paragraph);
      });
    });

    flushRows();

    if (foundRows) container.replaceChildren(output);
    container.dataset.structuredContentInitialized = 'true';
  }

  function initializeProductWeight(container) {
    if (container.dataset.weightInitialized === 'true') return;
    var source = container.querySelector('[data-product-weight-variants]');
    var fallback = container.querySelector('[data-backend-weight-table]');
    var row = container.querySelector('[data-backend-weight-row]');
    var content = container.previousElementSibling;
    if (!source || !fallback || !row || !content || !content.hasAttribute('data-structured-content')) return;
    var variants;
    try { variants = JSON.parse(source.textContent); } catch (error) { return; }
    if (!Array.isArray(variants)) return;
    var originalWeight = Array.prototype.find.call(content.querySelectorAll('tr'), function(item) {
      var label = item.querySelector('th, td');
      return label && /^(?:weight|product weight|item weight|net weight|shipping weight)$/i.test(label.textContent.trim().replace(/:$/, ''));
    });
    if (originalWeight) {
      fallback.remove();
      container.dataset.weightInitialized = 'true';
      container.dataset.weightPreserved = 'existing-specification';
      return;
    }
    var tables = content.querySelectorAll('table.susucar-metafield-table__table');
    var table = tables[tables.length - 1];
    if (table && table.tBodies.length) {
      table.tBodies[table.tBodies.length - 1].appendChild(row);
      fallback.remove();
    } else {
      table = fallback;
      content.appendChild(table);
    }
    var details = container.closest('[data-product-spec-accordion-item]');
    var hasOriginalContent = content.textContent.replace(row.textContent, '').trim().length > 0;
    var controller = new AbortController();
    var frame = 0;
    function masterSelect() {
      var select = document.getElementById('selected_variant');
      if (!select) return null;
      return Array.prototype.some.call(select.options || [], function(option) {
        return variants.some(function(variant) { return String(variant.id) === option.value; });
      }) ? select : null;
    }
    function show(variant) {
      var valid = variant && Number.isFinite(Number(variant.grams)) && Number(variant.grams) > 0;
      row.hidden = !valid;
      row.querySelector('[data-backend-weight-value]').textContent = valid ? variant.text : '';
      if (!hasOriginalContent) {
        table.hidden = !valid;
        if (details) details.hidden = !valid;
      }
    }
    function synchronize(useForm) {
      var select = masterSelect();
      var id = useForm && select ? select.value : container.dataset.selectedWeightVariant;
      var variant = variants.find(function(item) { return String(item.id) === String(id); });
      if (useForm && select) {
        var root = select.closest('.product-template');
        var optionControls = root && root.querySelectorAll('.js-swatch-form [name^="option"]');
        if (optionControls && optionControls.length) {
          var chosen = [];
          optionControls.forEach(function(control) {
            var index = Number(control.name.replace('option', '')) - 1;
            if (index >= 0 && (control.tagName === 'SELECT' || control.checked)) chosen[index] = control.value;
          });
          if (chosen.length) variant = variants.find(function(item) {
            return item.options.length === chosen.length && item.options.every(function(option, index) { return option === chosen[index]; });
          });
        }
      }
      show(variant);
    }
    function schedule(event) {
      var select = masterSelect();
      var root = select && select.closest('.product-template');
      if (event && event.type === 'change' && (!root || !root.contains(event.target) || !event.target.matches('#selected_variant, [name^="option"]'))) return;
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(function() { synchronize(true); });
    }
    document.addEventListener('change', schedule, { capture: true, signal: controller.signal });
    window.addEventListener('load', schedule, { once: true, signal: controller.signal });
    document.addEventListener('shopify:section:unload', function(event) {
      if (!event.target.contains(container)) return;
      controller.abort();
      window.cancelAnimationFrame(frame);
    }, { signal: controller.signal });
    synchronize(false);
    container.dataset.weightInitialized = 'true';
  }

  function initializeProductFaq(container) {
    if (container.dataset.faqInitialized === 'true') return;

    var source = container.querySelector('[data-faq-source]');
    var headings = source ? Array.prototype.filter.call(source.children, function(element) {
      return /^H[2-6]$/.test(element.tagName);
    }) : [];

    if (!source || !headings.length) {
      container.dataset.faqInitialized = 'true';
      return;
    }

    var list = document.createElement('div');
    list.className = 'product-page-faq__list';

    headings.forEach(function(heading, index) {
      var details = document.createElement('details');
      var summary = document.createElement('summary');
      var answer = document.createElement('div');
      var node = heading.nextSibling;

      details.className = 'product-page-faq__item';
      summary.className = 'product-page-faq__question';
      answer.className = 'product-page-faq__answer';
      summary.textContent = heading.textContent.trim();

      while (node && !(node.nodeType === 1 && /^H[2-6]$/.test(node.tagName))) {
        answer.appendChild(node.cloneNode(true));
        node = node.nextSibling;
      }

      if (index === 0 && container.dataset.openFirst === 'true') details.open = true;
      details.appendChild(summary);
      details.appendChild(answer);
      list.appendChild(details);
    });

    source.hidden = true;
    source.insertAdjacentElement('afterend', list);
    container.dataset.faqInitialized = 'true';
  }

  function copyText(value) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(value);
    }

    return new Promise(function(resolve, reject) {
      var textarea = document.createElement('textarea');
      textarea.value = value;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();

      try {
        document.execCommand('copy');
        resolve();
      } catch (error) {
        reject(error);
      } finally {
        textarea.remove();
      }
    });
  }

  function initializeCopyProductUrl(button) {
    if (button.dataset.copyInitialized === 'true') return;

    button.addEventListener('click', function() {
      var label = button.querySelector('span');
      var defaultLabel = button.dataset.copyLabel || 'Copy link';
      var copiedLabel = button.dataset.copiedLabel || 'Copied';

      copyText(button.dataset.copyProductUrl || window.location.href).then(function() {
        if (label) label.textContent = copiedLabel;
        button.setAttribute('aria-label', copiedLabel);

        window.setTimeout(function() {
          if (label) label.textContent = defaultLabel;
          button.setAttribute('aria-label', defaultLabel);
        }, 2000);
      });
    });

    button.dataset.copyInitialized = 'true';
  }

  function initializeNativeShare(button) {
    if (button.dataset.nativeShareInitialized === 'true') return;

    if (typeof navigator.share !== 'function') {
      var listItem = button.closest('li');
      if (listItem) listItem.hidden = true;
      button.dataset.nativeShareInitialized = 'true';
      return;
    }

    button.addEventListener('click', function() {
      navigator.share({
        title: button.dataset.shareTitle || document.title,
        url: button.dataset.shareUrl || window.location.href
      }).catch(function() {});
    });

    button.dataset.nativeShareInitialized = 'true';
  }

  function isVisible(element) {
    if (!element || !element.isConnected) return false;

    var styles = window.getComputedStyle(element);
    var rect = element.getBoundingClientRect();
    return styles.display !== 'none' && styles.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
  }

  function findButtonInRoot(root) {
    if (!root || !root.querySelectorAll) return null;

    var buttons = Array.prototype.slice.call(root.querySelectorAll('button, [role="button"]'));
    var labelPattern = /chat|message|conversation|assistance/i;

    for (var index = 0; index < buttons.length; index += 1) {
      var button = buttons[index];
      var label = (button.getAttribute('aria-label') || button.getAttribute('title') || button.textContent || '').trim();

      if (!button.hasAttribute('data-shopify-inbox-trigger') && labelPattern.test(label) && isVisible(button)) {
        return button;
      }
    }

    var elements = root.querySelectorAll('*');
    for (var elementIndex = 0; elementIndex < elements.length; elementIndex += 1) {
      if (elements[elementIndex].shadowRoot) {
        var shadowButton = findButtonInRoot(elements[elementIndex].shadowRoot);
        if (shadowButton) return shadowButton;
      }
    }

    return null;
  }

  function findShopifyInboxLauncher() {
    var containers = document.querySelectorAll([
      'shopify-chat',
      '#ShopifyChat',
      'inbox-online-store-chat',
      '[id*="shopify-chat" i]',
      '[class*="shopify-chat" i]',
      '[data-shopify-inbox]'
    ].join(','));

    for (var index = 0; index < containers.length; index += 1) {
      var container = containers[index];
      var launcher = findButtonInRoot(container.shadowRoot || container);
      if (launcher) return launcher;
    }

    return null;
  }

  function initializeShopifyInboxTrigger(button) {
    if (button.dataset.inboxInitialized === 'true') return;

    button.addEventListener('click', function() {
      var popup = button.closest('.susucar-product-popup');
      var status = popup ? popup.querySelector('[data-shopify-inbox-status]') : null;
      var attempts = 0;
      var event = new CustomEvent('susucar:shopify-inbox:open', { bubbles: true, cancelable: true });

      if (status) {
        status.hidden = true;
        status.textContent = '';
      }

      if (!document.dispatchEvent(event)) {
        if (window.Fancybox && typeof window.Fancybox.close === 'function') window.Fancybox.close();
        return;
      }

      function openLauncher() {
        var launcher = findShopifyInboxLauncher();
        attempts += 1;

        if (launcher) {
          if (window.Fancybox && typeof window.Fancybox.close === 'function') window.Fancybox.close();
          window.setTimeout(function() {
            launcher.focus();
            if (!/close/i.test(launcher.getAttribute('aria-label') || '')) launcher.click();
          }, 180);
          return;
        }

        if (attempts < 5) {
          window.setTimeout(openLauncher, 250);
          return;
        }

        var fallback = button.getAttribute('data-inbox-fallback');
        if (fallback) { window.location.assign(fallback); return; }

        if (status) {
          status.textContent = button.dataset.inboxUnavailable || 'Live chat is currently unavailable.';
          status.hidden = false;
        }
      }

      openLauncher();
    });

    button.dataset.inboxInitialized = 'true';
  }

  function reopenSuccessfulSupportForm(scope) {
    var success = (scope || document).querySelector('[data-support-form-success]');
    if (!success) return;

    var popup = success.closest('.susucar-product-popup');
    if (!popup) return;

    var trigger = document.querySelector('[data-src="#' + popup.id + '"]');
    if (trigger) window.setTimeout(function() { trigger.click(); }, 250);
  }

  function initializeProductBuilder(scope) {
    (scope || document).querySelectorAll('[data-delivery-estimate]').forEach(initializeDeliveryEstimate);
    (scope || document).querySelectorAll('[data-susucar-tabs]').forEach(initializeProductTabs);
    (scope || document).querySelectorAll('[data-product-spec-accordion]').forEach(initializeProductAccordion);
    (scope || document).querySelectorAll('[data-structured-content]').forEach(initializeStructuredContent);
    (scope || document).querySelectorAll('[data-product-weight]').forEach(initializeProductWeight);
    (scope || document).querySelectorAll('[data-product-faq]').forEach(initializeProductFaq);
    (scope || document).querySelectorAll('[data-copy-product-url]').forEach(initializeCopyProductUrl);
    (scope || document).querySelectorAll('[data-native-share]').forEach(initializeNativeShare);
    (scope || document).querySelectorAll('[data-shopify-inbox-trigger]').forEach(initializeShopifyInboxTrigger);
    reopenSuccessfulSupportForm(scope || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initializeProductBuilder(document);
    });
  } else {
    initializeProductBuilder(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initializeProductBuilder(event.target);
  });
})();

/* Only contact links with an explicitly configured WhatsApp number. */
(function () {
  if (window.SusucarContactLinks) return;
  function refresh(link) {
    var number = link.getAttribute('data-susu-whatsapp') || '';
    if (!/^[1-9]\d{6,14}$/.test(number)) return;
    var message = link.getAttribute('data-susu-wa-message') || '';
    if (link.getAttribute('data-susu-wa-page') !== 'false') {
      var page = new URL(window.location.href);
      var variant = page.searchParams.get('variant');
      page.search = ''; page.hash = '';
      if (/\/products\//.test(page.pathname) && /^\d+$/.test(variant || '')) page.searchParams.set('variant', variant);
      message = message ? message + '\n' + page.href : page.href;
    }
    var target = new URL('https://wa.me/' + number);
    if (message) target.searchParams.set('text', message);
    link.href = target.href;
  }
  function initialize(root) { (root || document).querySelectorAll('[data-susu-whatsapp]').forEach(refresh); }
  ['click', 'contextmenu', 'focusin', 'pointerdown'].forEach(function (name) {
    document.addEventListener(name, function (event) {
      var link = event.target.closest && event.target.closest('[data-susu-whatsapp]');
      if (link) refresh(link);
    }, true);
  });
  window.SusucarContactLinks = { initialize: initialize };
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  else initialize(document);
})();



